import Callout from "./Callout";
import UnsupportedVersionMessage from "./UnsupportedVersionMessage";

export const PartialSupportedBrowserVersion = ({
  browserName,
  browserVersion,
  requiredMinBrowserVersion,
  downloadPageLink,
  children,
}) => (
  <>
    <Callout>
      <UnsupportedVersionMessage
        {...{
          browserName,
          browserVersion,
          downloadPageLink,
          requiredMinBrowserVersion,
        }}
      />
    </Callout>
    {children}
  </>
);

export default PartialSupportedBrowserVersion;
